import React from 'react';

function HighlightCol(props) {
    return (
        <div className="col_row">
            <div className="photocontainer">
                <img src={props.url} alt={props.alt} id="photo_img" />
                <div className="display_content">
                    <p>
                        {props.context}
                                        </p>
                </div>
            </div>
        </div>
    );
}

export default HighlightCol;